import React from 'react';
import RegistrationScreen from './RegistrationScreen';
import './App.css';
import AdminDashboard from './AdminDashboard';

function App() {
  const [isAdmin, setIsAdmin] = React.useState(false);
  return (
    <div className="App">
      {isAdmin ? <AdminDashboard /> : <RegistrationScreen />}
      <button className="admin-toggle-btn" onClick={() => setIsAdmin(a => !a)}>
        {isAdmin
          ? <><span>👤</span> User View</>
          : <><span>⚙️</span> Admin View</>
        }
      </button>
    </div>
  );
}

export default App;
